import React from 'react'

interface checkoutLineItemProp {
    item_image: string,
    title: string
    subtitle: string
    price: string
    variant_title : string
    show: boolean
}

const CheckoutLineItem = ({ item_image, title, subtitle, price, variant_title, show }: checkoutLineItemProp) => {
    return (


      

        <div className={`lineItemProductsDetailsCheckout content ${show ? 'visible' : 'hidden'}`}  >
            <a href="#">
                <div className="productInfo">
                    <div className="productImage">
                        <img src={item_image} alt="" />
                    </div>
                    <div className="productTitle_wrapper">
                        <h3 className="productTitle">{title}</h3>
                        <div className="productSubTitle_variant">
                            <span className="productSubTitle">{subtitle} </span>
                            { variant_title !== "Default Title" ? <span className="separator"></span> : <span></span> }
                            { variant_title !== "Default Title" ? <span>{variant_title}</span> :<span></span> }
                        </div>
                       
                    </div>
                </div>
            </a>
            <div className="">
                <h4 className="productCompareAtPrice">Rs. {price} </h4>           
            </div>
        </div>

    )
}

export default CheckoutLineItem
